import { DataCache, SharedKeyRelationship } from 'lib/DataCache';

import { CoordinationCardDetailsResponse } from 'data/models/CoordinationCardDetailsResponse';

import { PCCache, PCCollection } from 'data/PCCache';

export class CoordinationCardDetailsCache extends DataCache {
    CoordinationCardDetailsResponses = PCCollection(CoordinationCardDetailsResponse);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship(this.CoordinationCardDetailsResponses, data.CoordinationCards, r => r.CoordinationCard, null);
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/coordinationcarddetails/cache.ts